// react core
import { useState } from "react";

// theming
import mainTheme from "components/main/MainTheme";
import { ThemeProvider, responsiveFontSizes } from "@mui/material/styles";

// material design
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

// fonts and icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsersViewfinder as iconTribeFinder } from "@fortawesome/pro-thin-svg-icons";
import { faCog as iconSettings } from "@fortawesome/pro-solid-svg-icons";
import { faBell as iconNotifications } from "@fortawesome/pro-duotone-svg-icons";
import { faTimes as iconClose } from "@fortawesome/pro-thin-svg-icons";

// entzy config and components
import configEntzy from "components/config/ConfigEntzy";
import MainModule from "components/main/MainModule";
import TribeSettings from "components/tribe/TribeSettings";
import { HeaderMenuTag } from "components/utils/common/CommonTags";
import { createMainMenuList } from "models/main";

function TribeIndex(props) {
  const moduleId = "tribe";
  const mainMenuList = createMainMenuList();
  const moduleInfo = mainMenuList.find((m) => m.id === moduleId);

  const [showAlertSettings, setShowAlertSettings] = useState(false);

  const handleToggleAlertSettings = () => {
    setShowAlertSettings(!showAlertSettings);
  };

  return (
    <ThemeProvider theme={responsiveFontSizes(mainTheme)}>
      <Box className="box-default">
        <HeaderMenuTag icon={iconTribeFinder} text={moduleInfo.name} />
        <Box
          className="box-default"
          sx={{
            p: configEntzy.APP_SPACING_MD,
            minHeight: "60vh",
          }}
        >
          <MainModule module={moduleId} {...props} />
        </Box>
        <Box
          className="box-default"
          sx={{
            pb: configEntzy.APP_SPACING_HL,
          }}
        >
          <Box
            className="box-inline action-pointer"
            sx={{
              p: configEntzy.APP_SPACING_MD,
            }}
            onClick={handleToggleAlertSettings}
          >
            <Typography variant="subtitle2">
              <span className="fa-layers fa-fw fa-2x">
                <FontAwesomeIcon icon={iconNotifications} color="orange" />
                <FontAwesomeIcon
                  icon={showAlertSettings ? iconClose : iconSettings}
                  transform="right-6 up-6 shrink-6"
                  color="white"
                />
              </span>
            </Typography>
            <Typography variant="subtitle2">Notification Settings</Typography>
          </Box>
        </Box>
        <Drawer
          anchor="bottom"
          open={showAlertSettings}
          onClose={handleToggleAlertSettings}
        >
          <Box className="box-default">
            <Box
              className="box-default"
              sx={{
                pt: configEntzy.APP_SPACING_MD2X,
                pr: configEntzy.APP_SPACING_MD2X,
              }}
            >
              <Box
                className="box-inline right action-pointer"
                onClick={handleToggleAlertSettings}
              >
                <Typography variant="subtitle2">
                  <FontAwesomeIcon icon={iconClose} size="2x" />
                </Typography>
              </Box>
            </Box>
            <Box
              className="box-default"
              sx={{
                mb: configEntzy.APP_SPACING_HL,
              }}
            >
              <Container maxWidth="xs" disableGutters>
                <TribeSettings {...props} />
              </Container>
            </Box>
          </Box>
        </Drawer>
      </Box>
    </ThemeProvider>
  );
}

export default TribeIndex;
